import React from 'react';
import AccountManager from '../../components/Business/AccountManager';

const AdminAccounts = () => {
  return <AccountManager mode="admin" />;
};

export default AdminAccounts;
